import React from 'react';

import { finleyAssertUnreachable } from '@finley-technologies/common';
import { CreditAgreement } from '@finley-technologies/finley-types';

import { CreditAgreementFullArtifactWipConfigType } from '../../../../types';
import { ReportingOutputDocxFileInsertionAthenaQueryOutput } from './ReportingOutputDocxFileInsertionAthenaQueryOutput';
import { ReportingOutputDocxFileInsertionPostgresQueryOutput } from './ReportingOutputDocxFileInsertionPostgresQueryOutput';

type ReportingOutputDocxFileInsertionOutputProps = {
  organizationId: string;
  fileInsertionOutput: CreditAgreement.Config.Reporting.Outputs.Docx.FileInsertionOutput;
  existingFileInsertionOutputs: CreditAgreement.Config.Reporting.Outputs.Docx.FileInsertionOutput[];
  wipConfig?: CreditAgreementFullArtifactWipConfigType;
  basePropertyKey: string;
  idx: number;
  presetVariables?: CreditAgreement.Config.QueryVariable[];
  validationVariables?: CreditAgreement.Config.QueryVariable[];
};
export const ReportingOutputDocxFileInsertionOutput = ({
  organizationId,
  fileInsertionOutput,
  existingFileInsertionOutputs,
  wipConfig,
  basePropertyKey,
  idx,
  presetVariables = [],
  validationVariables = [],
}: ReportingOutputDocxFileInsertionOutputProps) => {
  switch (fileInsertionOutput.config.fileType) {
    case 'athenaQuery':
      return (
        <ReportingOutputDocxFileInsertionAthenaQueryOutput
          fileInsertionOutputName={fileInsertionOutput.name}
          athenaQueryOutputConfig={fileInsertionOutput.config}
          existingFileInsertionOutputs={existingFileInsertionOutputs}
          basePropertyKey={basePropertyKey}
          fullPropertyKey={`${basePropertyKey}[${idx}]`}
          organizationId={organizationId}
          wipConfig={wipConfig}
          idx={idx}
          presetVariables={presetVariables}
          validationVariables={validationVariables}
        />
      );
    case 'postgresQuery':
      return (
        <ReportingOutputDocxFileInsertionPostgresQueryOutput
          fileInsertionOutputName={fileInsertionOutput.name}
          postgresQueryOutputConfig={fileInsertionOutput.config}
          existingFileInsertionOutputs={existingFileInsertionOutputs}
          basePropertyKey={basePropertyKey}
          fullPropertyKey={`${basePropertyKey}[${idx}]`}
          wipConfig={wipConfig}
          idx={idx}
        />
      );
    default:
      return finleyAssertUnreachable(fileInsertionOutput.config);
  }
};
